import React from "react";
import Globals from "../../api";
import ReactHtmlParser from "react-html-parser";

export default class commonPages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commonContents: [],
    };
  }

  componentDidMount() {
    const commonPageData = Globals.common_contents;
    fetch(commonPageData)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          commonContents: data.FooterLinks.Items,
        });
      });
  }

  render() {
    let url = window.location.pathname;

    if(url == '/advertise-with-us'){
       DataItems  = ` <div class="container">
      <ol class="breadcrumb">
        <li><a href="/">वेबदुनिया</a></li>
        <li class="active">Advertise With Us</li>
      </ol>
    </div>
  
  <div class="container">
    <div class="clearfix"></div>
    <div class="i_con_l">
      <div class="top_news bar_red wbx no_brdr_b">
        <div class="head">
          <h1>WEBDUNIA ADVERTISING !!!  </h1>
        </div>
      </div>
      
      <div class="ad_enq wbx">
        <h2>AD ENQUIRY FOR WEB</h2>      
          <div class="ad_enq_col">
            <h3>Mr. Prateek Chadhokar </h3>
              <ul>
                <!--<li><i class="ico_call"></i> +91 98934-26966 </li>-->
                  <li><i class="ico_phone"></i>0731-475-6121</li>
                  <li><i class="ico_mail"></i><a href="mailto:prateek.chadhokar@webdunia.net" class="adv-email-link">prateek.chadhokar@webdunia.net</a></li>
                  <li><i class="ico_skype"></i><a href="skype:cid.9ec12a85c1e7a44?chat" class="adv-skype-link">skype:cid.9ec12a85c1e7a44</a></li>
              </ul>
          </div>
      </div>
      <a href="http://advertise.webdunia.com" target="_blank"><img src="https://hindi.webdunia.com/img/ad_enq_img.jpg" class="ad_enq_img"></a>
      <div class="ad_enq wbx">
        <div class="ad_enq_col">
              <h2> Head Office </h2>
              <h3> Indic Media Pvt. Ltd. </h3>
            <h4>"Webdunia-Diaspark Campus", 60/1 Babu Labhchand Chhajalani Marg, Kesar Bag Road, Indore - 452009, MP [India] </h4>
              <ul>
                <li><i class="ico_phone"></i> 0731-475-6064  </li>
                  <li><i class="ico_fax"></i>+91 731 254 8555  </li>
                  <li><a href="mailto:adsales@webdunia.net" class="adv-email-link">adsales@webdunia.net</a></li>
              </ul>
          </div>
          <div class="ad_enq_col">
            <h2>Branch Office - USA  </h2>
            <h3> Indic Media Pvt. Ltd. </h3>
            <h4>Indic Media  2018 156th Ave NE, Suite 100, Bellevue, WA - 98007  </h4>
              <ul>
                <li><i class="ico_phone"></i>+1 425 223 1361 </li>
                  <li><i class="ico_fax"></i>+1 425 449 4601  </li>
                  
              </ul>
          </div>
      </div>
      <div class="ad_enq wbx">
        <div class="ad_enq_col">
            <h2> Branch Office- Mumbai  </h2>
            <h3> Indic Media Pvt. Ltd. </h3>
            <h4> 810, B Wing, BSEL Tech Park,
          Plot No.39-5 & 39-5a, Sector 30A,
          Vashi, Navi Mumbai - 400703, MH [India] </h4>
              <ul>
                <li><i class="ico_phone"></i>+91-022-49786542  </li>
                
                 
              </ul>
          </div>
          <div class="ad_enq_col">
            <h2>Branch Office - Chennai  </h2>
            <h3> Indic Media Pvt. Ltd. </h3>
            <h4>5th floor, Alpha Center
        149-152 North Usman Road
        T Nagar
        Chennai - 600017, TN [India] </h4>
           <ul>  <li><i class="ico_phone"></i> +91-44-28140071-72-73-74 </li></ul>
          </div>
      </div>  
    </div>
           
      </div>	
    `;
    return ReactHtmlParser(DataItems);
    }

    else if (url == '/contact-us') {
      DataItems  = `
      <style> 
        a {color: #A50404;}
      .contactus_page .page_title {
          padding-bottom: 15px;
          padding-top: 20px;
      }
      .contactus_page a{color:#A50404;}
      .contact_us_block1, .contact_us_block2 {
        border: 1px dashed #A50404;
          padding: 15px 15px;
          text-align: center;
          margin-bottom: 10px;
          border-radius: 15px;
          float: left;
          max-width: 540px;
          margin-right: 15px;
          min-height: 250px;
      }
        
        
      }
      .contactus_page h4 {
          font-size: 16px;
          font-weight: 600;
          margin: 12px 0;
      }
      .disclaimer_page .page_title {
          padding-bottom: 15px;
          padding-top: 20px;
      }
      .disclaimer_page a{color:#A50404;}
      .disclaimer_page ul {
          margin: 0;
          padding-left: 20px;
      }
      .privacy_p_page .page_title {
          padding-bottom: 15px;
          padding-top: 20px;
      }
      .aboutus_page .page_title {
          padding-bottom: 15px;
          padding-top: 20px;
      }
      .aboutus_blocks {
          /*display: flex;
          flex-wrap: wrap;*/
          list-style: none;
          padding: 0;
          margin-bottom: 10px;
          display: flex;
      }
      .aboutus_page a{color:#A50404;}
      .aboutus_blocks:after{content:""; clear: both; display: table;}
      .aboutus_blocks li {
         
          border: 1px solid #ddd;
          text-align: center;
          
      }
      .a_blocks {
          padding: 10px;
          text-align: center;
          font-size: 14px;
          background: #fff;
          font-weight: 600;
      }
      .a_blocks b {
          display: block;
          font-size: 28px;
          font-weight: 300;
          color: #A50404;
      }
      .page_title h1 {
          font-size: 24px;
          margin: 0;
          padding: 0;
          line-height: 30px;
          color: #221f1f;
          font-weight: 600;
      }
          </style>
          <link href="https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap" rel="stylesheet">
        <div class="container m-b-20 contactus_page">
      
            <div class="page_title">
              <h1>Contact us- </h1>
            </div>
            <h4>Thank You for visiting our site. We value our users and would be happy to hear from you. Please connect with
              us in case of any queries, concerns or for any kind of feedbacks.</h4>
      
            <div class="contact_us_block1">
            
              <p>For any Content published on Webdunia.com or to get any information you can email to us on editorial@webdunia.net or You can also write to us :
              </p>
            </div>
      
            <div class="contact_us_block2">
            <p>Indic Media Pvt. Ltd.</p> 
        <p>"Webdunia-Diaspark Campus", 60/1 Babu Labhchand Chhajalani Marg, Kesar Bag Road, Indore - 452009, MP [India]
            </p>
            <p><b>Contact :editorial@webdunia.net | Phone No - 0731-4756001-02</p>
          </div>
          <div class="clearfix"></div>		
          <b>Disclaimer</b>: Kindly do not post any defamatory, infringing, obscene, indecent, discriminatory or unlawful material or information. Indic Media Pvt Ltd reserves the right to remove any content received from users/readers without notice.</p>
            
                       <p><b>To advertise on Webdunia network sites/app, click <a href="/advertise-with-us">Advertise with Us</a> </b></p>
            <p><b>To know more about Webdunia , click <a href="/about-us">About Us</a></b></p>
          </div>
        
    `;
    return ReactHtmlParser(DataItems);
    }
    else{
    let pageContents = this.state.commonContents.filter(
      (x) => x.DefaultUrl == `${url}`
    );
    {
      var DataItems = pageContents.map((item) => {
        var htmlContent = item.Pagehtml;
        return ReactHtmlParser(htmlContent);
      });
    }
  }
    return <div className="container padding15">{DataItems}</div>;
  }
}
